// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GLjK_uNeZEqPKitBZ7ds{padding:2px 2px 2px 0}`, "",{"version":3,"sources":["webpack://./src/pages/analytics/ui/TrendLabel/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,qBAAA","sourcesContent":[".trendLabel {\n  padding: 2px 2px 2px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trendLabel": `GLjK_uNeZEqPKitBZ7ds`
};
export default ___CSS_LOADER_EXPORT___;
